import { render } from "./AiGenerationProductData.vue?vue&type=template&id=37016bce&scoped=true"
import script from "./AiGenerationProductData.vue?vue&type=script&lang=js"
export * from "./AiGenerationProductData.vue?vue&type=script&lang=js"

import "./AiGenerationProductData.vue?vue&type=style&index=0&id=37016bce&lang=scss"
import "./AiGenerationProductData.vue?vue&type=style&index=1&id=37016bce&lang=scss&scoped=true"
import "./AiGenerationProductData.vue?vue&type=style&index=2&id=37016bce&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37016bce"]])

export default __exports__